import { useTranslation } from "react-i18next";
import { getOperatorsFromAvailableFilters } from "../../helpers/helpersSearchs";

const useDashboardFilters = () => {
  const [t] = useTranslation("global");

  const filterNames = {
    id: t("Data.table.Details"),
    sites: t("Users_tables.columns_table_one.sites"),
    computedStatusId: t("custom_filter.userFacingDeletion"),
  };

  const filtersList = [
    {
      columnField: "sites",
      sortable: false,
    },
    {
      columnField: "computedStatusId",
      sortable: false,
    },
  ];

  const getFilters = () => {
    const filters: any[] = filtersList.map((filter) => {
      if (filter.columnField === "computedStatusId") {
        return {
          field: filter.columnField,
          headerName: (filterNames as never)[filter.columnField],
          width: 250,
          disableColumnMenu: true,
          sortable: false,
          type: "string",
          filterOperators: getOperatorsFromAvailableFilters(["$eq", "$ne"]),
          filter: "API",
          service: "computedStatusId",
          queryFormat: "computedStatusId",
        };
      }

      if (filter.columnField === "sites") {
        return {
          field: filter.columnField,
          headerName: (filterNames as never)[filter.columnField],
          width: 250,
          disableColumnMenu: true,
          sortable: false,
          type: "string",
          filterOperators: getOperatorsFromAvailableFilters(["$in"]),
          filter: "API",
          service: "geoPoints",
          queryFormat: "geoPointName[$in][]=",
        };
      }
      return {
        field: filter.columnField,
        headerName: (filterNames as never)[filter.columnField],
        filterable: true,
        sortable: false,
        disableColumnMenu: true,
        editable: true,
      };
    });

    return filters;
  };

  return { filter: getFilters };
};

export default useDashboardFilters;
